<h2 mat-dialog-title>Manage Defaults</h2>
<mat-dialog-content>
  <table>
    <tr>
      <th>Type</th>
      <th>Display</th>
      <th>Coding</th>
    </tr>
    <tr>
      <td>Standard & Admin User</td>
      <td>
        <mat-form-field>
          <mat-select [(value)]="standardLayoutDisplay">
            <mat-option>No Default</mat-option>
            <mat-optgroup label="Shared">
              <mat-option *ngFor="let layout of sharedLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
            <mat-optgroup label="Pinned">
              <mat-option *ngFor="let layout of pinnedLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
            <mat-optgroup label="Recent">
              <mat-option *ngFor="let layout of recentLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </td>
      <td>
        <mat-form-field>
          <mat-select [(value)]="standardLayoutCoding">
            <mat-option>No Default</mat-option>
            <mat-optgroup label="Shared">
              <mat-option *ngFor="let layout of sharedLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
            <mat-optgroup label="Pinned">
              <mat-option *ngFor="let layout of pinnedLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
            <mat-optgroup label="Recent">
              <mat-option *ngFor="let layout of recentLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </td>
    </tr>

    <tr>
      <td>Review User</td>
      <td>
        <mat-form-field>
          <mat-select [(value)]="reviewLayoutDisplay" disabled>
            <mat-option>No Default</mat-option>
            <mat-optgroup label="Shared">
              <mat-option *ngFor="let layout of sharedLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
            <mat-optgroup label="Pinned">
              <mat-option *ngFor="let layout of pinnedLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
            <mat-optgroup label="Recent">
              <mat-option *ngFor="let layout of recentLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </td>
      <td>
        <mat-form-field>
          <mat-select [(value)]="reviewLayoutCoding">
            <mat-option>No Default</mat-option>
            <mat-optgroup label="Shared">
              <mat-option *ngFor="let layout of sharedLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
            <mat-optgroup label="Pinned">
              <mat-option *ngFor="let layout of pinnedLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
            <mat-optgroup label="Recent">
              <mat-option *ngFor="let layout of recentLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </td>
    </tr>

    <tr>
      <td>Limited User</td>
      <td>
        <mat-form-field>
          <mat-select [(value)]="limitedLayoutDisplay" disabled>
            <mat-option>No Default</mat-option>
            <mat-optgroup label="Shared">
              <mat-option *ngFor="let layout of sharedLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
            <mat-optgroup label="Pinned">
              <mat-option *ngFor="let layout of pinnedLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
            <mat-optgroup label="Recent">
              <mat-option *ngFor="let layout of recentLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </td>
      <td>
        <mat-form-field>
          <mat-select [(value)]="limitedLayoutCoding">
            <mat-option>No Default</mat-option>
            <mat-optgroup label="Shared">
              <mat-option *ngFor="let layout of sharedLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
            <mat-optgroup label="Pinned">
              <mat-option *ngFor="let layout of pinnedLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
            <mat-optgroup label="Recent">
              <mat-option *ngFor="let layout of recentLayouts" [value]="layout.fieldLayoutId">{{layout.displayTitle}}</mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </td>
    </tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" (click)="ok()">OK</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
